import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=81a09b78&scoped=true&"
import script from "./Audio.vue?vue&type=script&lang=js&"
export * from "./Audio.vue?vue&type=script&lang=js&"
import style0 from "./Audio.vue?vue&type=style&index=0&id=81a09b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a09b78",
  null
  
)

export default component.exports